import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  landscapeBackground: null,
  useGreyBg: false,
  exceedFilterWarning: false,
  unseenExportCount: 0,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setLandscapeBackground: (state, action) => {
      state.landscapeBackground = action.payload;
    },
    setExceedFilterWarning: (state, action) => {
      state.exceedFilterWarning = action.payload;
    },
    setUseGreyBg: (state, action) => {
      state.useGreyBg = action.payload;
    },
    setUnseenExportCount: (state, action) => {
      state.unseenExportCount = action.payload;
    },
  },
});

export const { setLandscapeBackground, setExceedFilterWarning, setUseGreyBg, setUnseenExportCount } =
  commonSlice.actions;
export default commonSlice.reducer;
